import useSWR, {SWRConfiguration} from 'swr';
import letrusAPI from 'APIs/letrusAPI/axiosInstance';
import useSWRMutation from 'swr/mutation';
import {CompositionReview} from './types';

export function fetchCompositionReview(
  id: number | string,
  SWRConfig?: SWRConfiguration<CompositionReview>,
) {
  return useSWR<CompositionReview>(
    `/api/v1/composition_reviews/${id}/`,
    (url) => letrusAPI(url).then((res) => res.data),
    {revalidateOnFocus: false, shouldRetryOnError: false, ...SWRConfig},
  );
}

export function updateHasSeenCompositionRequest() {
  return useSWRMutation<null, Error, string, {id: number}>(
    `/api/v1/composition_reviews`,
    async (url, {arg}) => {
      try {
        const response = await letrusAPI(`${url}/${arg.id}/see_review/`, {
          method: 'post',
        });

        return response.data;
      } catch (error: any) {
        const errorMessage =
          error?.response?.data?.non_field_errors?.[0] ??
          error?.response?.data?.detail ??
          error?.response?.data?.[0];

        throw new Error(errorMessage);
      }
    },
    {
      throwOnError: false,
    },
  );
}
